module.exports = __webpack_public_path__ + "static/media/usg-usd-button.c0399159.png";